import { TRPCClientError } from "@trpc/client";
import type { AppRouter } from "../../../data-service/src/trpcRouters/root";

const isTrpcError = (error: unknown): error is TRPCClientError<AppRouter> =>
  error instanceof TRPCClientError;

/** A message suitable for showing to the user. */
export const getErrorMessage = (error: unknown): string => {
  if (isTrpcError(error)) {
    // No response data means the request never reached the API.
    if (!error.data) {
      return "Can't reach the server. Check your connection and try again.";
    }
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Something went wrong.";
};
